import React from "react";

interface Props {
  title: React.ReactNode;
  body?: string;
  headingId?: string;
}

const SectionHead = ({ title, body, headingId }: Props) => (
  <div className="section-head">
    <h2 id={headingId}>{title}</h2>
    {body && <p>{body}</p>}
  </div>
);

export default SectionHead;
